import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  // Add JWT token to Authorization header if available
  const userStore = useUserStoreWithOut()
  const token = userStore.getToken
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data.code === SUCCESS_CODE) {
    // Extract and store token from login response if present
    if (response.data.data?.token) {
      const userStore = useUserStoreWithOut()
      userStore.setToken(response.data.data.token)
    }
    return response.data
  } else {
    // Show error message for non-success responses
    const errorMsg = response?.data?.message || response?.data?.msg || 'Request failed'

    // Handle 401 UNAUTHORIZED (token expired or invalid)
    if (response?.data?.code === 401 || response?.status === 401) {
      // Check if it's a token expiration error
      if (
        errorMsg.includes('Token has expired') ||
        errorMsg.includes('token') ||
        errorMsg.includes('expired') ||
        errorMsg.includes('unauthorized') ||
        response?.data?.code === 401
      ) {
        const userStore = useUserStoreWithOut()
        ElMessage.error('登录已过期，请重新登录')
        // Force logout and redirect to login page
        userStore.logout()
      } else {
        // Other 401 errors, still show error message
        ElMessage.error(errorMsg)
      }
    } else {
      // Non-401 errors, show error message
      ElMessage.error(errorMsg)
    }
    // Always return response.data so caller can handle the error
    return response.data
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
